import React, { useEffect, useState } from 'react';

const EquipmentChecklistModal = ({ itemId, equipmentId, onClose, onSubmit, initialData = {} }) => {
  const [formData, setFormData] = useState({
    name: '',
    criteria: '',
    equipment_id: equipmentId,
    user_id: sessionStorage.getItem('user_id') || ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validated, setValidated] = useState(false);

  // Populate form when editing
  useEffect(() => {
    if (initialData && itemId) {
      setFormData({
        ...initialData,
        equipment_id: initialData.equipment_id || equipmentId,
        user_id: initialData.user_id || sessionStorage.getItem('user_id') || ''
      });
    }
  }, [initialData, itemId, equipmentId]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Form validation before submit
  const validateForm = () => {
    if (!formData.name.trim() || !formData.criteria.toString().trim()) {
      setValidated(true);
      return false;
    }
    return true;
  };

  // Submit form
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    const success = await onSubmit({ ...formData, id: itemId });
    if (success) onClose();
    setIsSubmitting(false);
  };

  return (
    <div
      className="modal fade show"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {itemId ? 'Edit Checklist Item' : 'Add Checklist Item'}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <form>
              <div className="row mb-3">
                {/* Name Field */}
                <div className="col-md-6">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${validated && !formData.name.trim() ? 'is-invalid' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {validated && !formData.name.trim() && (
                    <div className="text-danger mt-1">Name is required.</div>
                  )}
                </div>

                {/* Criteria Field */}
                <div className="col-md-6">
                  <label className="form-label">
                    Criteria <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    name="criteria"
                    className={`form-control ${validated && !formData.criteria.toString().trim() ? 'is-invalid' : ''}`}
                    value={formData.criteria}
                    onChange={handleChange}
                  />
                  {validated && !formData.criteria.toString().trim() && (
                    <div className="text-danger mt-1">Criteria is required.</div>
                  )}
                </div>
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-outline-danger"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1"></span>
                  {itemId ? 'Updating...' : 'Creating...'}
                </>
              ) : (
                itemId ? 'Update Item' : 'Create Item'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentChecklistModal;
